import React from 'react';

let currentUser = null;

export function setErrorLoggerUser(user) {
  currentUser = user;
}

export async function logError(errorData) {
  try {
    const payload = {
      message: errorData.message || 'Unknown error',
      stackTrace: errorData.stack || errorData.stackTrace || null,
      component: errorData.component || null,
      route: window.location.pathname,
      severity: errorData.severity || 'error',
      metadata: errorData.metadata || {},
      userId: currentUser?.id || null,
      userEmail: currentUser?.email || null,
      userAgent: navigator.userAgent
    };

    if (errorData.componentStack) {
      payload.metadata.componentStack = errorData.componentStack;
    }

    console.log('[ErrorLogger] Sending error to server:', payload.message, payload.component);
    
    const response = await fetch('/api/error-log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('[ErrorLogger] Server rejected error log:', response.status, errorText);
    } else {
      console.log('[ErrorLogger] Error logged successfully');
    }
  } catch (e) {
    console.error('[ErrorLogger] Failed to send error to server:', e.message);
  }
}

export function initGlobalErrorHandlers() {
  window.onerror = function(message, source, lineno, colno, error) {
    logError({
      message: message || 'Unknown error',
      stack: error?.stack || `${source}:${lineno}:${colno}`,
      component: 'window.onerror',
      severity: 'error',
      metadata: {
        source,
        lineno,
        colno
      }
    });
    return false;
  };

  window.onunhandledrejection = function(event) {
    const error = event.reason;
    logError({
      message: error?.message || String(error) || 'Unhandled Promise Rejection',
      stack: error?.stack || null,
      component: 'unhandledrejection',
      severity: 'error',
      metadata: {
        type: 'promise_rejection'
      }
    });
  };
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logError({
      message: error.message,
      stack: error.stack,
      component: this.props.componentName || 'ErrorBoundary',
      severity: 'critical',
      metadata: {
        componentStack: errorInfo.componentStack
      }
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-[50vh] flex items-center justify-center">
          <div className="text-center p-8">
            <h2 className="text-xl font-light text-white mb-2">Something went wrong</h2>
            <p className="text-white/60 text-sm font-normal mb-4">
              We've logged this error and are looking into it.
            </p>
            <button 
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg text-sm font-normal transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
